import { useEffect } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBuyerDetails } from "../../Actions/BuyerAction";
import { globalStyle } from "../../global/Utils";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import Swal from "sweetalert2";

const ViewBuyer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const buyerId = searchParams.get("id");
  const { buyerDetailsList, isGettingBuyerDetails } = useSelector(
    (state) => state.BuyerReducer,
  );
  const handleDangerVisibleForBuyerDetails = () => {
    Swal.fire({
      title: "Error",
      text: "Buyer Not Found",
      icon: "error",
      timer: 30000,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/main/view-buyer-list");
      }
    });
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(getBuyerDetails(buyerId, handleDangerVisibleForBuyerDetails));
    });
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [dispatch, buyerId]);
  if (!buyerId) {
    return Navigate({ to: "/main/view-buyer-list" });
  }
  return (
    <>
      {isGettingBuyerDetails ? (
        <div className="relative min-h-screen">
          <div className="absolute inset-0 flex items-center justify-center">
            <CircularProgress size={50} color="success" />
          </div>
        </div>
      ) : (
        <div
          className="p-6 animate-fade-in"
          style={{ fontFamily: globalStyle.fontFamily }}
        >
          <button
            onClick={() => navigate("/main/view-buyer-list")}
            className="mb-4 px-4 py-2 rounded text-white"
            style={{
              background: globalStyle.buttonColor,
              fontFamily: globalStyle.fontFamilyButton,
            }}
          >
            ← Back
          </button>
          <h2
            className="text-2xl font-bold mb-4 text-center"
            style={{
              color: globalStyle.blueColor,
              fontFamily: globalStyle.fontFamilyHeading,
            }}
          >
            Buyer Profile
          </h2>
          <div
            className="grid grid-cols-1 md:grid-cols-2 gap-6"
          >
            {[
              { label: "Name", value: buyerDetailsList?.businessName },
              {
                label: "Contact",
                value: buyerDetailsList?.contact
                  ? `+${buyerDetailsList?.contact}`
                  : "-",
              },
              { label: "Address", value: buyerDetailsList?.address },
              {
                label: "Registration Type",
                value: buyerDetailsList?.registrationType,
              },
              { label: "Province", value: buyerDetailsList?.province },
              // A Registered buyer always has a number; an Unregistered one
              // added "With CNIC" keeps the one it was looked up by.
              (buyerDetailsList?.registrationType === "Registered" ||
                buyerDetailsList?.registrationNo) && {
                label: "Registration No",
                value: buyerDetailsList?.registrationNo,
              },
              // Saved when the buyer was added; "-" for a buyer added before
              // these checks existed.
              (buyerDetailsList?.registrationType === "Registered" ||
                buyerDetailsList?.salesTaxStatus) && {
                label: "Sales Tax Status",
                value: buyerDetailsList?.salesTaxStatus || "-",
              },
              (buyerDetailsList?.registrationType === "Registered" ||
                buyerDetailsList?.atlStatus) && {
                label: "ATL Status",
                value: buyerDetailsList?.atlStatus || "-",
              },
              {
                label: "Created At",
                value: moment(buyerDetailsList?.createdAt).format("LLL"),
              },
            ]
              ?.filter(Boolean)
              ?.map((item, index) => (
                <div key={index}>
                  <p className="font-semibold text-gray-600">{item.label}:</p>
                  <p
                    className="text-base"
                    style={{ color: globalStyle.blueColor }}
                  >
                    {item.value}
                  </p>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ViewBuyer;
